export default __webpack_public_path__ + "static/media/cancelWhite.805c856c.svg";